import { initialState } from '../state';
import { ExecutedPathActions, ExecutedPathActionTypes } from '../actions';
import { Activity } from '@ispm-shared/modules/bpmn';

export function executedActivities(state = initialState.executedActivities, action: ExecutedPathActions): Activity[] {
  switch (action.type) {
    case ExecutedPathActionTypes.UPDATE_EXECUTED_ACTIVITIES:
      return action.payload.executedActivities;
    case ExecutedPathActionTypes.CLEAR_EXECUTION_HISTORY:
      return null;
    case ExecutedPathActionTypes.CLEAR_ITEMS_TO_SELECT:
      return null;
    default: {
      return state;
    }
  }
}
